import type { AnalysisAssigneeClusterBand, AnalysisAssigneeLoad } from '../types/analysis'
import { computeBaseline } from './analysisStatistics'

export const buildAssigneeClusters = (assigneeLoad: AnalysisAssigneeLoad[]): Map<string, AnalysisAssigneeClusterBand> => {
  const clusters = new Map<string, AnalysisAssigneeClusterBand>()
  const { mean, stddev } = computeBaseline(assigneeLoad.map((row) => row.total))
  for (const row of assigneeLoad) {
    const band: AnalysisAssigneeClusterBand = row.total === 0 ? 'IDLE'
      : stddev === 0 ? 'MEDIUM'
      : row.total >= mean + stddev ? 'HIGH'
      : row.total < mean - stddev ? 'LOW'
      : 'MEDIUM'
    clusters.set(row.id, band)
  }
  return clusters
}
